/** UI catalog — initial release: OpenAI only. Groq/OpenRouter deferred (see BYOK_PROVIDERS_DEFERRED). */
export type ByokProviderId = 'openai';

export type ByokProviderModel = {
  id: string;
  labelKey: string;
  labelFallback: string;
};

export type ByokProviderDefinition = {
  id: ByokProviderId;
  /** Backend `AiByokProvider` when `available`. */
  backendProvider?: 'openai';
  nameKey: string;
  nameFallback: string;
  descriptionKey: string;
  descriptionFallback: string;
  keyUrlKey: string;
  keyUrlFallback: string;
  keyUrlHref: string;
  defaultBaseUrl: string;
  available: boolean;
  models?: ByokProviderModel[];
  badgeClassName: string;
};

export const BYOK_OPENAI_MODELS: ByokProviderModel[] = [
  { id: 'gpt-4o', labelKey: 'aiByok.providers.openai.models.gpt4o', labelFallback: 'GPT-4o' },
  { id: 'gpt-4o-mini', labelKey: 'aiByok.providers.openai.models.gpt4oMini', labelFallback: 'GPT-4o mini' },
  { id: 'o3-mini', labelKey: 'aiByok.providers.openai.models.o3Mini', labelFallback: 'o3 mini' },
  { id: 'o4-mini', labelKey: 'aiByok.providers.openai.models.o4Mini', labelFallback: 'o4 mini' },
];

export const BYOK_PROVIDER_CATALOG: ByokProviderDefinition[] = [
  {
    id: 'openai',
    backendProvider: 'openai',
    nameKey: 'aiByok.providers.openai.name',
    nameFallback: 'OpenAI',
    descriptionKey: 'aiByok.providers.openai.description',
    descriptionFallback: 'Use your OpenAI API key for chat, embeddings, and suggestions.',
    keyUrlKey: 'aiByok.providers.openai.keyUrl',
    keyUrlFallback: 'Get your OpenAI API key here',
    keyUrlHref: 'https://platform.openai.com/api-keys',
    defaultBaseUrl: 'https://api.openai.com/v1',
    available: true,
    models: BYOK_OPENAI_MODELS,
    badgeClassName: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  },
];

/** Post-launch: append to `BYOK_PROVIDER_CATALOG` once runtime supports each provider. */
export const BYOK_PROVIDERS_DEFERRED = ['groq', 'openrouter'] as const;

export const DEFAULT_OPENAI_CHAT_MODEL = 'gpt-4o-mini';
